import React, { useEffect, useState } from 'react';
import { Link, NavLink, useLocation, useNavigate } from 'react-router-dom';
import Logo from './Logo.jsx';
import { SearchIcon, BagIcon, HeartIcon, MenuIcon, CloseIcon } from './Icons.jsx';
import { useStore } from '../context/StoreContext.jsx';

const NAV = [
  { label: 'New Arrivals', to: '/shop/new-arrivals' },
  { label: 'Clothing', to: '/shop/clothing' },
  { label: 'Handbags', to: '/shop/handbags' },
  { label: 'Best Sellers', to: '/shop/best-sellers' },
  { label: 'Sale', to: '/shop/sale', accent: true },
  { label: 'Korean Wear', to: '/korean-wear', note: 'Soon' },
];

export default function Header() {
  const { settings, cartCount, wishlist, setDrawer } = useStore();
  const [menu, setMenu] = useState(false);
  const [search, setSearch] = useState(false);
  const [q, setQ] = useState('');
  const navigate = useNavigate();
  const { pathname } = useLocation();

  useEffect(() => { setMenu(false); setSearch(false); }, [pathname]);
  useEffect(() => {
    document.body.style.overflow = menu ? 'hidden' : '';
    return () => { document.body.style.overflow = ''; };
  }, [menu]);

  const submit = (e) => {
    e.preventDefault();
    const term = q.trim();
    if (term) navigate(`/shop?q=${encodeURIComponent(term)}`);
  };

  return (
    <>
      {settings.announcement && (
        <div className="announce"><p>{settings.announcement}</p></div>
      )}
      <header className="header">
        <div className="header__row">
          <div className="header__left">
            <button type="button" className="iconbtn header__burger" onClick={() => setMenu(true)} aria-label="Open menu">
              <MenuIcon />
            </button>
            <button type="button" className="iconbtn header__search-desktop" onClick={() => setSearch((s) => !s)} aria-label="Search">
              <SearchIcon />
            </button>
          </div>
          <div className="header__logo"><Logo size={56} /></div>
          <div className="header__right">
            <button type="button" className="iconbtn header__search-mobile" onClick={() => setSearch((s) => !s)} aria-label="Search">
              <SearchIcon />
            </button>
            <button type="button" className="iconbtn header__wish" onClick={() => setDrawer('wishlist')} aria-label="Wishlist">
              <HeartIcon />
              {wishlist.length > 0 && <span className="count">{wishlist.length}</span>}
            </button>
            <button type="button" className="iconbtn" onClick={() => setDrawer('cart')} aria-label="Shopping bag">
              <BagIcon />
              {cartCount > 0 && <span className="count">{cartCount}</span>}
            </button>
          </div>
        </div>

        <nav className="nav" aria-label="Main">
          {NAV.map((n) => (
            <NavLink key={n.to} to={n.to} className={`nav__link${n.accent ? ' nav__link--sale' : ''}`}>
              {n.label}{n.note && <em>{n.note}</em>}
            </NavLink>
          ))}
        </nav>

        {search && (
          <form className="searchbar" onSubmit={submit} role="search">
            <input
              autoFocus
              type="search"
              value={q}
              onChange={(e) => setQ(e.target.value)}
              placeholder="Search for products"
              aria-label="Search for products"
            />
            <button type="submit" className="btn btn--small">Search</button>
          </form>
        )}
      </header>

      <div className={`drawer-backdrop${menu ? ' is-open' : ''}`} onClick={() => setMenu(false)} />
      <aside className={`menu${menu ? ' is-open' : ''}`} aria-hidden={!menu}>
        <div className="menu__head">
          <Logo size={48} />
          <button type="button" className="iconbtn" onClick={() => setMenu(false)} aria-label="Close menu"><CloseIcon /></button>
        </div>
        <nav className="menu__links">
          {NAV.map((n) => (
            <Link key={n.to} to={n.to} className={n.accent ? 'is-sale' : ''}>
              {n.label}{n.note && <em>{n.note}</em>}
            </Link>
          ))}
          <hr />
          <button type="button" className="menu__wish" onClick={() => { setMenu(false); setDrawer('wishlist'); }}>
            Wishlist{wishlist.length > 0 ? ` (${wishlist.length})` : ''}
          </button>
          <Link to="/about">About Us</Link>
          <Link to="/contact">Contact Us</Link>
          <Link to="/privacy-policy">Privacy Policy</Link>
          <Link to="/terms-conditions">Terms and Conditions</Link>
        </nav>
      </aside>
    </>
  );
}
